import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";

import LoadingWheel from "../../components/shared/LoadingWheel";
import { PlusSmallIcon } from "@heroicons/react/24/outline";
import useSuppliers from "../../data/useSuppliers";
import { ISupplier } from "../../models/Supplier";
import SuppliersTable from "../../components/suppliers/SuppliersTable";
import SuppliersModal from "../../components/suppliers/SuppliersModal";
import useCustomer from "../../data/useCustomer";
// import SuppliersTable from "../../components/suppliers/SuppliersTable";
// import SuppliersModal from "../../components/suppliers/SuppliersModal";

export default function Suppliers() {
    const { setInfo } = usePageNameContext();
    const { suppliers: allSuppliers, create, sync } = useSuppliers();
    const { hasWilmaPro } = useCustomer();
    const [wilmaPro, setWilmaPro] = useState<boolean>(false);
    const [suppliers, setSuppliers] = useState<ISupplier[] | undefined>(undefined);
    const [supplier, setSupplier] = useState<ISupplier | undefined>(undefined);

    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [createOpen, setCreateOpen] = useState(false);

    useEffect(() => {
        setInfo({
            name: "Suppliers",
            desc: "Manage suppliers",
        });
    }, []);

    useEffect(() => {
        if (!allSuppliers.isLoading && allSuppliers.data) {
            // Filtering code goes here
            setSuppliers(allSuppliers.data?.data);
            setIsLoading(false);
        }
    }, [allSuppliers.isLoading, allSuppliers.data, searchTerm]);

    useEffect(() => {
        if (hasWilmaPro.data) {
            setWilmaPro(hasWilmaPro.data.data);
        }
    }, [hasWilmaPro.data]);

    const handleSetSupplier = (supplier: ISupplier) => {
        setSupplier(supplier);
        setCreateOpen(true);
    }

    const handleAddSupplier = () => {
        setSupplier(undefined);
        setCreateOpen(true);
    }

    const handleSyncSuppliers = () => {
        sync.mutate({}, {
            onSuccess: () => {
                // Optionally show a success message or perform additional actions
            },
            onError: (error) => {
                // Handle error case
                console.error("Error syncing suppliers:", error);
            }
        });
    }

    if (allSuppliers.isLoading || isLoading) {
        return (
            <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
                <LoadingWheel />
            </div>
        );
    }

    return (
        <>
            <SuppliersModal open={createOpen} setOpen={setCreateOpen} supplier={supplier} />
            <div className="mt-4 flex flex-wrap gap-2">
                <button
                    className="bg-primary-600 hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
                    onClick={handleAddSupplier}
                >
                    <PlusSmallIcon className="h-5 w-5 mr-2" />
                    Add Supplier
                </button>
                {wilmaPro && (
                    <button
                        className="bg-secondary-600 hover:bg-secondary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
                        onClick={handleSyncSuppliers}
                    >
                        Sync Wilma Accounts
                    </button>
                )}
            </div>

            <SuppliersTable suppliers={suppliers ?? []} setSupplier={handleSetSupplier} />
        </>
    );


}